var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tender-information"},[_c('TenderGeneralInformation',{attrs:{"tender":_vm.tender}}),_c('TenderEmitterInformation',{attrs:{"emitter":_vm.tender.emitter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }